import FechamentoView from "../../components/estoque/FechamentoView";

export default function FechamentoEstoque() {
  return <FechamentoView />;
}
